import React from 'react';
import { Navigation, Pagination, Autoplay, A11y } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import constants from '../../lib/constants';

import IconCoffee from '../../img/icon_coffee.svg';

function HomeExplore({banners}){
    return (
        <div className='home_explore'>
            <div className="container">
                <div className="title-common d-flex align-items-center">
                    <img src={IconCoffee} alt="" />
                    <h2>探索更多</h2>
                </div>
                <Swiper
                    className='banner-content home_explore_swiper pb-0'
                    modules={[Navigation, Pagination, Autoplay, A11y]}
                    spaceBetween={0}
                    slidesPerView={1}
                    loop={true}
                    navigation
                    pagination={{ clickable: true }}
                    speed={800}
                    autoplay={{
                        delay: 10000,
                        disableOnInteraction: false,
                    }}
                >
                    {
                      banners.map(banner => 
                            <SwiperSlide key={banner.id}>
                                <div className='row'>
                                    <div className="col-lg-6">
                                        <div className="home_explore_pic"><img src={`${constants.imageBaseUrl}/${banner.image}`} alt="" /></div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="home_explore_text">
                                            <h3>{banner.title}</h3>
                                            <p>{banner.description}</p>
                                            <a className='btn-common' href={banner.link}>了解更多</a>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            )
                    }
                </Swiper>
            </div>
            
        </div>
        
    );
}

export default HomeExplore;